import React, { useEffect, useRef, useState } from "react";
import AntRobot from "./class/AntRobot";
import World from "./class/World";
const FRAME_WIDTH = 800;
const FRAME_HEIGHT = 600;
const INTERVAL_TIME = 50;
const POINT_SIZE = 10;
const NUM_ANTS = 5;

export default function CanvasAntSimulation() {
    const canvasRef = useRef(null);
    const [world, setWorld] = useState(() => {
        // 1. Create the world
        const newWorld = new World(FRAME_WIDTH, FRAME_HEIGHT);
        // 2. Create some random ants(living entities)
        for (let i = 0; i < NUM_ANTS; i++) {
            const ant = new AntRobot(
                Math.floor(Math.random() * (FRAME_WIDTH - POINT_SIZE)),
                Math.floor(Math.random() * (FRAME_HEIGHT - POINT_SIZE)),
                i,
                newWorld
            );
            newWorld.addEntity(ant);
        }
        return newWorld;
    });

    const [isRunning, setIsRunning] = useState(false);
    const [showRadar, setShowRadar] = useState(false);
    const [showTrail, setShowTrail] = useState(false);

    useEffect(() => {
        let intervalId;
        if (isRunning) {
            intervalId = setInterval(() => {
                // 3. Always keep moving the entities
                world.entities.forEach((ent) => ent.move());
                // 4. Update the world state!
                setWorld(Object.assign(Object.create(Object.getPrototypeOf(world)), world));
            }, INTERVAL_TIME);
        }
        return () => clearInterval(intervalId);
    }, [isRunning, world]);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.clearRect(0, 0, FRAME_WIDTH, FRAME_HEIGHT);

        world.entities.forEach((ent) => {
            // Trail
            if (showTrail) {
                for (let i = 0; i < ent.trail.length - 1; i++) {
                    const a = ent.trail[i];
                    const b = ent.trail[i + 1];
                    const opacity = ((i + 1) / ent.trail.length) * 0.9;
                    ctx.strokeStyle = `rgba(0, 255, 255, ${opacity})`;
                    ctx.lineWidth = 2;
                    ctx.beginPath();
                    ctx.moveTo(a.x + POINT_SIZE / 2, a.y + POINT_SIZE / 2);
                    ctx.lineTo(b.x + POINT_SIZE / 2, b.y + POINT_SIZE / 2);
                    ctx.stroke();
                }
            }

            // Collision Marks
            ent.marks.forEach((mark) => {
                ctx.fillStyle = "limegreen";
                ctx.beginPath();
                ctx.arc(mark.x + POINT_SIZE / 2, mark.y + POINT_SIZE / 2, POINT_SIZE / 3, 0, Math.PI * 2);
                ctx.fill();
            });

            // Trail Intersections
            if (showTrail) {
                ent.trailIntersections.forEach((intersection) => {
                    ctx.fillStyle = "red";
                    ctx.beginPath();
                    ctx.arc(intersection.x + POINT_SIZE / 2, intersection.y + POINT_SIZE / 2, POINT_SIZE / 3, 0, Math.PI * 2);
                    ctx.fill();
                });
            }

            // Radar of each entity looking for next trail point (nearByFoundedTrailPoints)
            // Prevent null
            if (showRadar) {
                if (ent.followingTrail && ent.nearByPositions) {
                    const lastDirection = ent.nearByPositions[ent.nearByPositionsCurrentIndex];
                    if (lastDirection) {
                        ctx.strokeStyle = "yellow";
                        ctx.lineWidth = 1;
                        ctx.beginPath();
                        // Draw a circle in the currentPosition + lastDirection[0]and [1]
                        ctx.arc(
                            ent.x + POINT_SIZE / 2 + lastDirection[0],
                            ent.y + POINT_SIZE / 2 + lastDirection[1],
                            POINT_SIZE / 2,
                            0,
                            Math.PI * 2
                        );
                        ctx.stroke();
                    }
                }
            }

            // Ant body
            ctx.fillStyle = "white";
            ctx.beginPath();
            ctx.arc(ent.x + POINT_SIZE / 2, ent.y + POINT_SIZE / 2, POINT_SIZE / 2, 0, Math.PI * 2);
            ctx.fill();
        });
    }, [world]);

    return (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button
                onClick={() => {
                    setIsRunning((r) => !r)
                    // wait time_interval /2 and
                }}
                style={{ padding: "10px 20px", fontSize: "16px" }}
            >
                {isRunning ? "Stop" : "Start"} Ants
            </button>
            <button
                onClick={() => {
                    // 3. Always keep moving the entities
                    world.entities.forEach((ent) => ent.move());
                    // 4. Update the world state!
                    setWorld(Object.assign(Object.create(Object.getPrototypeOf(world)), world));
                }
                }
                style={{ padding: "10px 20px", fontSize: "16px", marginLeft: "10px" }}
            >
                Step Forward
            </button>
            {/* Button switch show radar */}
            <button
                onClick={() => setShowRadar((r) => !r)}
                style={{ padding: "10px 20px", fontSize: "16px", marginLeft: "10px" }}
            >
                {showRadar ? "Hide Radar" : "Show Radar"}
            </button>
            {/* Button switch show trail */}
            <button
                onClick={() => setShowTrail((r) => !r)}
                style={{ padding: "10px 20px", fontSize: "16px", marginLeft: "10px" }}
            >
                {showTrail ? "Hide Trail" : "Show Trail"}
            </button>
            <div
                style={{
                    width: FRAME_WIDTH,
                    height: FRAME_HEIGHT,
                    margin: "20px auto",
                    background: "black",
                }}
            >
                <canvas ref={canvasRef} width={FRAME_WIDTH} height={FRAME_HEIGHT} style={{ display: "block" }} />
            </div>
        </div>
    );
}
